import { render, staticRenderFns } from "./tower.vue?vue&type=template&id=4b932562&scoped=true"
import script from "./tower.vue?vue&type=script&lang=js"
export * from "./tower.vue?vue&type=script&lang=js"
import style0 from "./tower.vue?vue&type=style&index=0&id=4b932562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b932562",
  null
  
)

export default component.exports